import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { ScrollToTop } from '@utils';

import { Category, FAQ, Question } from './pages';

export default function Routing() {
  return (
    <Router basename="/faq/">
      <ScrollToTop />
      <Switch>
        <Route exact path="/" component={FAQ} />
        <Route path="/:category/:question/" component={Question} />
        <Route path="/:category/" component={Category} />
      </Switch>
    </Router>
  );
}
